<template>
  <v-container class="custom-container container" >
  <div class="list_form_card" >
    <h1>ช้อมูลผู้ใช้งาน</h1>

    <v-row>
      <v-col class="filter-container" >
        <date-range-picker
            v-model="dateRange"
            :auto-apply="true"
            :show-dropdowns="true"
            :ranges="Ranges"
            :locale-data="Lang"
        ></date-range-picker>
      </v-col>
    </v-row>




    <v-row>
      <v-col xl="12" lg="12" md="12" sm="12" xs="12" >
        <div align="center" >
          <div class="box-visit-all" >
            <span class="head-title" >ผู้ใช้งานทั้งหมด</span>
            <span class="amount" >100</span>
          </div>
        </div>
      </v-col>
        <v-col xl="4" lg="4" md="6" sm="12" xs="12" >
          <div align="center" >
            <div class="box-visit" >
              <span class="head-title" >รายวัน</span>
              <span class="amount" >0</span>
            </div>
          </div>
      </v-col>
      <v-col xl="4" lg="4" md="6" sm="12" xs="12" >
        <div align="center" >
          <div class="box-visit" >
            <span class="head-title" >รายสัปดาห์</span>
            <span class="amount" >0</span>
          </div>
        </div>
      </v-col>
      <v-col xl="4" lg="4" md="6" sm="12" xs="12" >
        <div align="center" >
          <div class="box-visit" >
            <span class="head-title" >รายเดือน</span>
            <span class="amount" >0</span>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>



  </v-container>


</template>

<script>
// @ is an alias to /src

import moment from "moment";

let today = new Date();
today.setHours(0, 0, 0, 0);
today.setDate(today.getDate() + 2);

let yesterday = new Date();
yesterday.setDate(today.getDate() - 1);
yesterday.setHours(0, 0, 0, 0);

let last7 = new Date();
last7.setDate(today.getDate() - 7);
last7.setHours(0, 0, 0, 0);

let last15 = new Date();
last15.setDate(today.getDate() - 15);
last15.setHours(0, 0, 0, 0);

export default {
  name: 'Home',
  computed: {
    moment() {
      return moment
    }
  },
  components: {

  },
  data: () => ({
    type: 'month',
    types: ['month', 'week', 'day', '4day'],
    mode: 'stack',
    modes: ['stack', 'column'],
    value: '',
    dateShow: '',
    headersVisit: [
      {text: 'เชิญชวนจาก',align:'center',  value:'users_code'},
      {text: 'วันที่เพิ่มข้อมูล',align:'center', value: 'created_at'},
    ],
    headersGuestVisit: [
      {text: 'ชื่อผู้เข้าชม',align:'center',  value:'guestdata'},
      {text: 'เชิญชวนจาก',align:'center',  value:'users_code'},
      {text: 'หน้าเว็บ',align:'center',  value:'route'},
      {text: 'วันที่เพิ่มข้อมูล',align:'center', value: 'created_at'},
    ],
    headersGuest: [
      {text: 'ชื่อ-สกุล', key:'full_name' , value:'full_name'},
      {text: 'เชิญชวนจาก',align:'center',  value:'users_code'},
      {text: 'อึเมล',align:'center', value: 'email'},
      {text: 'เบอรโทร',align:'center', value: 'tel'},
      {text: 'วันที่เพิ่มข้อมูล',align:'center', value: 'created_at'},
    ],
    headersGuestRegister: [
      {text: 'ชื่อ-สกุล', key:'full_name' , value:'full_name'},
      {text: 'เชิญชวนจาก',align:'center',  value:'users_code'},
      {text: 'อึเมล',align:'center', value: 'email'},
      {text: 'เบอรโทร',align:'center', value: 'tel'},
      {text: 'วันเกิด',align:'center', value: 'about.dob'},
      {text: 'วุฒิการศึกษา',align:'center', key:'edu' ,value: 'edutext'},
      {text: 'ที่อยู่',align:'center', key:'provinces', value: 'address'},
      {text: 'วันที่เพิ่มข้อมูล',align:'center', value: 'created_at'},
    ],
    events: [],
    user: [],
    machine: [],
    bookingData: [],
    dialog: true,
    bookingUser: [],
    hour: [],
    hour_sleep: '',
    detail: '',
    minute_sleep: '',
    hour_awake: '',
    valid: true,
    minute_awake: '',
    userRegister: 0,
    recruiter_list: [],
    recruiter:"",
    date_booking: '',
    minute: [],
    machine_id: '',
    user_id: '',
    colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
    names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
    attributes: [],
    donate: [],
    items: [
      {
        text: 'Home',
        disabled: false,
        href: '/',
      },
    ],

    dialogGuest:false,
    resultDataGuest:[],
    itemsPerPageGuest: 1,
    loadingGuest: true,
    totalItemsGuest: 0,
    optionsGuest: {},

    dialogGuestRegister:false,
    resultDataGuestRegister:[],
    itemsPerPageGuestRegister: 1,
    loadingGuestRegister: true,
    totalItemsGuestRegister: 0,
    optionsGuestRegister: {},

    dialogVisit:false,
    resultDataVisit:[],
    itemsPerPageVisit: 1,
    loadingVisit: true,
    totalItemsVisit: 0,
    optionsVisit: {},


    dialogGuestVisit:false,
    resultDataGuestVisit:[],
    itemsPerPageGuestVisit: 1,
    loadingGuestVisit: true,
    totalItemsGuestVisit: 0,
    optionsGuestVisit: {},

    visit:0,
    visitGuest:0,
    guestView:0,
    guestRegister:0,

    dateRange: {
      startDate: last7,
      endDate: today,
    },
    dateFormat: "Y-m-d",
    Ranges: {
      '15 วันก่อนหน้า': [last15, today],
      'วันนี้': [today, today],
      'เมื่อวาน': [yesterday, yesterday],
      'ปีนี้': [
        new Date(today.getFullYear(), 0, 1),
        new Date(today.getFullYear(), 11, 31),
      ],
      'เดือนก่อน': [
        new Date(today.getFullYear(), today.getMonth() - 1, 1),
        new Date(today.getFullYear(), today.getMonth(), 0),
      ],
    },
    Lang: {
      direction: "ltr",
      format: "mm-dd-yyyy",
      separator: " - ",
      applyLabel: "ตกลง",
      cancelLabel: "ยกเลิก",
      weekLabel: "W",
      customRangeLabel: "เลือกช่วงเวลา",
      daysOfWeek: ["อา.", "จ.", "อ.", "พ.", "พฤ", "ศ", "ส"],
      monthNames: [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค.",
      ],
      firstDay: 1,
    }

  }),
  watch: {
  },
  methods:{

  },
  async mounted() {

  }
}
</script>
<style scoped >
.form_table{
  width: 80%;
}
.filter-container{
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;
}
.export-btn{
  background: #4CAF50;
  margin-left: 1rem;
  color: white;
}
.export-btn i{
  color: white;
}
.box-visit-all{
  min-width: 20rem;
  background: #F5A623;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 40%;
  padding: 1rem;
  padding-right: 2rem;
  padding-left: 2rem;
  border-radius: 1rem;
}
.box-visit-all .head-title{
  font-size: 2rem;
  color: #33302d;
}
.box-visit-all .amount{
  font-size: 5rem;
  font-weight: bold;
  color: #33302d;
}

.box-visit{
  min-width: 20rem;
  background: #F5A623;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 90%;
  padding: 1rem;
  padding-right: 2rem;
  padding-left: 2rem;
  border-radius: 1rem;
}
.box-visit .head-title{
  font-size: 2rem;
  color: #33302d;
}
.box-visit .amount{
  font-size: 5rem;
  font-weight: bold;
  color: #33302d;
}

</style>

